import { render } from "./adminManage.vue?vue&type=template&id=65dd0dc6"
import script from "./adminManage.vue?vue&type=script&lang=js"
export * from "./adminManage.vue?vue&type=script&lang=js"

import exportComponent from "E:\\zanbiya\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__